<template>
  <v-footer app inset class="font-weight-medium">
    <v-col class="text-center" cols="12">
      &copy;{{ new Date().getFullYear() }} —
      <strong
        ><a
          href="https://banky.studio"
          target="_blank"
          class="text-decoration-none"
          >Bankole</a
        >
      </strong>
    </v-col>
  </v-footer>
</template>

<script>
export default {};
</script>

<style>
</style>